import { useState, useMemo, useCallback } from 'react'
import includeUserTagsFilterStrategy from 'utils/insightModal/strategy/searchFilterComposing/includeUserTagsStrategy'
import includedProductHierarchyFilterStrategy from 'utils/insightModal/strategy/searchFilterComposing/includeProductHierarchyStategy'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import includedUserTagsWidgetSettingStrategy from 'utils/insightModal/strategy/widgetSettingComposing/includedUserTagsStrategy'
import includedProductHierarchyWidgetSettingStrategy from 'utils/insightModal/strategy/widgetSettingComposing/includedProductHierarchyMultipleAndStrategy'
import { InsightContentSettingType } from 'components/insightContent/types'

import {
  convertToInsightContentSetting,
  addSelectionFilterToWidgetSetting
} from './share/InsightModal/utils'
import { TagsWidgetsType, ExtendedInsightData } from './types'

const filterStrategyByViewOption = (viewOption: InsightViewOptionStrings) => {
  switch (viewOption) {
    case InsightViewOption.DOC_HIERARCHY:
      return includedProductHierarchyFilterStrategy()
    case InsightViewOption.TAGS:
    default:
      return includeUserTagsFilterStrategy()
  }
}

const widgetSettingComposingStrategyByViewOption = (viewOption: InsightViewOptionStrings) => {
  switch (viewOption) {
    case InsightViewOption.DOC_HIERARCHY:
      return includedProductHierarchyWidgetSettingStrategy()
    case InsightViewOption.TAGS:
    default:
      return includedUserTagsWidgetSettingStrategy()
  }
}

const useSelectedInsights = (widgetSetting: TagsWidgetsType) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedInsights, setSelectedInsights] = useState<ExtendedInsightData[]>([])

  const detailSetting = useMemo<InsightContentSettingType | undefined>(() => {
    if (isModalOpen && selectedInsights.length > 0) {
      const strategy = filterStrategyByViewOption(widgetSetting.viewOption!)
      return convertToInsightContentSetting(widgetSetting, strategy, selectedInsights)
    }
    return undefined
  }, [isModalOpen, widgetSetting, selectedInsights])

  const widgetSettingWithSelection = useMemo<any>(() => {
    if (isModalOpen && selectedInsights.length > 0) {
      const widgetSettingComposingStrategy = widgetSettingComposingStrategyByViewOption(
        widgetSetting.viewOption!
      )
      return addSelectionFilterToWidgetSetting(widgetSetting, widgetSettingComposingStrategy, {
        insights: selectedInsights
      })
    }
    return undefined
  }, [isModalOpen, widgetSetting, selectedInsights])

  const handleRowClick = useCallback((targetRow: ExtendedInsightData) => {
    setSelectedInsights([targetRow])
    setIsModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
    setSelectedInsights([])
  }, [])

  return {
    isModalOpen,
    selectedInsights,
    handleRowClick,
    handleCloseModal,
    detailSetting,
    widgetSettingWithSelection
  }
}

export default useSelectedInsights
